import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
    selector: 'loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
    @Input() public type: 'page' | 'component' = 'component';
    @Input() public bgFill = false;
    @Input() public isFullscreen = true;
    @Input() public color: '#fff' | '#1A8DCC' = '#fff';
    @Input() public message?: string;
    public lottieOptions: AnimationOptions = {
        path: 'assets/json/loader.json',
        renderer: 'svg',
        loop: true,
        autoplay: true,
    };

    public constructor() {}

    public ngOnInit() {}
}
